import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { downloadByZip } from "../../utils/downloadFile";
import "./index.less";
const ToolPackage = () => {
  const logoList = [
    {
      url: "//files.authing.co/authing-website/media-authing-jpg.png",
      name: "Authing.LOGO.jpg",
      zip: [
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-white.jpg",
          name: "authing-logo-pattern-white.jpg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-blue.jpg",
          name: "authing-logo-pattern-blue.jpg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-white.jpg",
          name: "authing-logo-complete-white.jpg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-blue.jpg",
          name: "authing-logo-complete-blue.jpg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-white.jpg",
          name: "authing-logo-complete-vertical-white.jpg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-blue.jpg",
          name: "authing-logo-complete-vertical-blue.jpg" + Date.now(),
        },
      ],
    },
    {
      url: "//files.authing.co/authing-website/media-authing-png.png",
      name: "Authing.LOGO.png",
      zip: [
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-white.png",
          name: "authing-logo-pattern-white.png" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-blue.png",
          name: "authing-logo-pattern-blue.png" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-white.png",
          name: "authing-logo-complete-white.png" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-blue.png",
          name: "authing-logo-complete-blue.png" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-white.png",
          name: "authing-logo-complete-vertical-white.png" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-blue.png",
          name: "authing-logo-complete-vertical-blue.png" + Date.now(),
        },
      ],
    },
    {
      url: "//files.authing.co/authing-website/media-authing-svg.png",
      name: "Authing.LOGO.svg",
      zip: [
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-white.svg",
          name: "authing-logo-pattern-white.svg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-blue.svg",
          name: "authing-logo-pattern-blue.svg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-white.svg",
          name: "authing-logo-complete-white.svg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-blue.svg",
          name: "authing-logo-complete-blue.svg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-white.svg",
          name: "authing-logo-complete-vertical-white.svg" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-blue.svg",
          name: "authing-logo-complete-vertical-blue.svg" + Date.now(),
        },
      ],
    },
    {
      url: "//files.authing.co/authing-website/media-authing-ai.png",
      name: "Authing.LOGO.ai",
      zip: [
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-white.ai",
          name: "authing-logo-pattern-white.ai" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-pattern-blue.ai",
          name: "authing-logo-pattern-blue.ai" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-white.ai",
          name: "authing-logo-complete-white.ai" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-blue.ai",
          name: "authing-logo-complete-blue.ai" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-white.ai",
          name: "authing-logo-complete-vertical-white.ai" + Date.now(),
        },
        {
          downloadUrl:
            "https://files.authing.co/authing-website/authing-logo/logo-complete-vertical-blue.ai",
          name: "authing-logo-complete-vertical-blue.ai" + Date.now(),
        },
      ],
    },
  ];
  const [active, setActive] = useState(-1);
  const { t } = useTranslation();
  return (
    <div>
      <Header mode="dark" />
      <div className="tool-package">
        <div className="tool-package-container">
          <div className="title">
            <div>
              <span style={{ color: "#396aff" }}>Authing </span>
              <span>{t("common.tool-package.title")}</span>
            </div>
            <div className="subtitle">{t("common.tool-package.subtitle")}</div>
          </div>
          <div className="content">
            {logoList.map((item, index) => (
              <div
                key={index + "sanbjscb"}
                className="content-item"
                onMouseOut={() => {
                  setActive(-1);
                }}
                onMouseOver={() => {
                  setActive(index);
                }}
                onClick={() =>
                  downloadByZip(item?.zip, `${item?.name + Date.now()}`)
                }
              >
                <img className="logo-img" src={item?.url} alt="authing" />
                <div
                  className={`logo-text ${active === index ? "active" : ""}`}
                >
                  <div>
                    <i className="icon authing-icon authing-attachment-line link-icon"></i>
                    <span>{item?.name}</span>
                  </div>
                  <div className="download-icon">
                    <i className="icon authing-icon authing-download-line1"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export { ToolPackage };
